/* global Foundation */
import $ from 'jquery'

export function initBusinessInfo () {
  $(document).ready(function () {
    if ($('body.supplier_onboardings-controller.business_info-action').length === 0) return

    const verified = $('[data-is-verified]')[0]?.dataset.isVerified === 'true'

    if (!verified) {
      setTimeout(function () {
        const $modalDiv = $('#set-password')
        if ($modalDiv.length > 0 && window.Foundation && window.Foundation.Reveal) {
          const popup = new Foundation.Reveal($modalDiv)
          popup.open()
        }
      }, 1500)
    }

    function setContactField (input) {
      $('.toggle').hide()
      $('.toggle-' + $(input).val()).show()
    }

    setContactField($('#supplier_contact_us_type'))

    $('#supplier_contact_us_type').change(function (field) {
      setContactField(field.target)
    })
  })
}
